import { IStorageUser, OnlineStorage } from "@tblabs/storage";
import { Div, Text } from "@tblabs/truffle";
import { Router } from "../Services/Router";


export class UserSectionWhenLoggedIn extends Div
{
    constructor(_storage: OnlineStorage, _router: Router)
    {
        super("user-section");

        _storage.OnUserChange((u: IStorageUser) =>
        {
            this.Clear().Append(
                new Text(u.Icon).Class("user-section__avatar"),
                new Div("user-section__info").Append(
                    new Text(u.Name).Class("user-section__name"),
                    new Text(u.Role).Class("user-section__role")
                )
            );
        });
    }
}
